// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SupportAlert } from '@/components/support-alert';
import { Box, Container } from '@mui/material';

interface Props {
  /**
   * An optional message to display on the error page. If a message is not
   * provided, a default message will be displayed.
   */
  message?: string;
}

/**
 * A component that renders an error alert in a page container.
 */
export function ErrorPage(props: Props) {
  const message = props.message ?? "We're sorry, but an error occurred.";

  return (
    <Box paddingY={2}>
      <Container maxWidth="md">
        <SupportAlert message={message} />
      </Container>
    </Box>
  );
}
